import { isPlatformBrowser } from '@angular/common';
import { EnvironmentProviders, PLATFORM_ID, Provider, inject, provideAppInitializer } from '@angular/core';

import { Logger, WINDOW } from '@frontend/vanilla/core';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG } from '../view-transition.constants';
import { HistoryApiBackDetectionStrategy } from './strategies/history-api-back-detection.strategy';
import { BrowserBackDetectionStrategy } from './strategies/model/browser-back-detection.strategy.model';
import { NavigationApiBackDetectionStrategy } from './strategies/navigation-api-back-detection.strategy';

export class BrowserBackDetectionService {
    readonly #logger = inject(Logger);
    readonly #windowRef = inject(WINDOW);

    #strategy?: BrowserBackDetectionStrategy;

    get strategy() {
        return this.#strategy;
    }

    init(): void {
        const isNavigationApiSupported = this.#windowRef.navigation;

        if (isNavigationApiSupported) {
            this.#logger.info(`${LOG_TAG} Using Navigation Api strategy for browser back detection`);

            this.#strategy = new NavigationApiBackDetectionStrategy().init();
        } else {
            this.#logger.info(`${LOG_TAG} Using History Api strategy for browser back detection`);

            this.#strategy = new HistoryApiBackDetectionStrategy().init();
        }
    }
}

export const provideBrowserBackDetection = (): (Provider | EnvironmentProviders)[] => {
    return [BrowserBackDetectionService, provideAppInitializer(browserBackDetectionInitializer)];
};

const browserBackDetectionInitializer = (): void => {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
        inject(BrowserBackDetectionService).init();
    }
};
